/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

import { GenerateEntrypointsCommand } from "../../library/commands/generateEntrypoints.js";

export default class GenerateEntrypointsCommand_ extends GenerateEntrypointsCommand {}
